import { MovementOptionQuery, MovementsFilterParamsProps } from './types';

export const movementItemsSelect = {
  title: { default: 'Selecione o tipo:', modal: 'Tipo' },
  items: [
    { label: 'CONTA CORRENTE', value: 'CurrentAccount' },
    { label: 'FUNDO DE INVESTIMENTO', value: 'Funds' },
    { label: 'RENDA FIXA', value: 'FixedIncome' },
    { label: 'TESOURO DIRETO', value: 'Treasury' },
    { label: 'AÇÕES', value: 'Equity' },
    { label: 'CLUBES', value: 'Clubs' },
    { label: 'OFERTAS PÚBLICAS', value: 'PublicOffering' },
  ],
};

export const movementRadioItemsSelect = {
  title: { default: 'Período', modal: 'Período' },
  items: [
    { label: 'Últimos 7 dias', value: 'LastSevenDays' },
    { label: 'Últimos 15 dias', value: 'LastFifthDays' },
    { label: 'Mensal', value: 'Month' },
    { label: 'Outros', value: 'Other' },
  ],
};

export const initialFilterTypedOption = movementRadioItemsSelect.items[0].value;
export const initialSelectedOption = movementItemsSelect.items[0].value as MovementOptionQuery;

export const defaultParams = {
  filterType: initialFilterTypedOption,
  limit: 40,
} as Partial<MovementsFilterParamsProps>;
